import React, { memo } from 'react';
import { Table, Column } from 'react-virtualized';
import classNames from 'classnames';
import { formatNumberToPlaces } from 'utils/numbers';
import { Box } from 'components/Wrapped';
import { PrettyNumberTZ } from 'components/Helpers';
import styles from './OrderTable.module.scss';

const renderVolumeBar = ({ side, width, maxVolume }) => ({ cellData }) => {
  return (
    <div
      className={classNames(styles.depthBar, styles[side])}
      style={{
        width: maxVolume ? (cellData / maxVolume) * width : 0,
      }}
    />
  );
};

const renderPrice = ({ side, precision }) => ({ cellData, rowIndex, ...rest }) => {
  return (
    <PrettyNumberTZ
      number={formatNumberToPlaces(cellData, precision, { trim: false })}
      handleClickValues={{ updatedOrderSide: side }}
      color={side === 'ask' ? '#E56150' : '#46B08E'}
      size="12px"
      weight={500}
      style={{ lineHeight: '16px' }}
    />
  );
};

const renderVolume = ({ cellData }) => {
  return (
    <Box pad="none" align="end">
      <PrettyNumberTZ
        addTrailing={false}
        number={formatNumberToPlaces(cellData, 4, {
          trim: true,
        })}
        size="12px"
        weight={500}
        style={{ lineHeight: '16px' }}
      />
    </Box>
  );
};

const renderTotal = ({ rowData: { volume, price } }) => {
  return (
    <Box pad="none" align="end">
      <PrettyNumberTZ
        number={formatNumberToPlaces(volume * price, 2, {
          trim: true,
        })}
        size="12px"
        weight={500}
        style={{ lineHeight: '16px' }}
      />
    </Box>
  );
};

const OrderTable = memo((props) => {
  const { tableData, side, height, width, handleRowClick, maxVolumeAsk, tradeAmountDecimals, tickDecimals } = props;

  return (
    <Table
      height={height}
      width={width}
      headerHeight={0}
      disableHeader={true}
      rowCount={tableData.length}
      rowGetter={({ index }) => tableData[index]}
      rowHeight={21}
      scrollToIndex={tableData.length - 1}
      rowClassName={styles.row}
      onRowClick={({ rowData, index }) => handleRowClick(side, rowData, tableData.length - 1 - index)}
    >
      <Column
        flexGrow={1}
        dataKey="price"
        width={100}
        cellRenderer={renderPrice({
          side,
          precision: tickDecimals,
        })}
        className="alignRight"
        style={{ marginLeft: 0 }}
      />
      <Column flexGrow={1} dataKey="volume" width={100} cellRenderer={renderVolume} className="alignRight" />
      <Column
        dataKey="total"
        width={100}
        flexGrow={1}
        cellRenderer={renderTotal}
        className={styles.orderBookTableColumn}
        style={{ margin: '0 0 0 4px' }}
      />
      <Column
        flexGrow={0}
        width={0}
        className={`${styles.depthContainer} hidden`}
        headerClassName="hidden"
        dataKey="volume"
        cellRenderer={renderVolumeBar({
          width,
          side,
          maxVolume: maxVolumeAsk,
          precision: tradeAmountDecimals,
        })}
      />
    </Table>
  );
});

export default OrderTable;
